import RoundTab from "components/RoundTabButtons/RoundTab";
import React from "react";

import Plus from "../../assets/img/icons/plus_white.svg";
import crossWhite from "../../assets/img/icons/remove_assignee.svg";
import ComponentCircleLoader from "../../components/Loaders/ComponentCircleLoader";
import NoDataComponent from "../../components/NoDataComponent/NoDataComponent";
import { ClearOrgSearchButton } from "../../components/Search/searchStyles";
import {
  ButtonIcon,
  ColoredButtonWithIcon,
  TabButton,
  TabButtonContainer,
} from "../../styledComponents/buttons";
import {
  CommonGrid,
  CommonImage,
  Container,
  FilterLabel,
  HeaderContainer,
  InputField,
  InputWithLabelSection,
  PageTitle,
} from "../../styledComponents/common";
import { TabLeftGrid } from "../../styledComponents/members";
import AppOnboardingIndividualPage from "../../components/AppOnboarding/AppOnboardingIndividualPage";
import EditOrganizationModal from "./EditOrganizationModal";
import OrganizationsTable from "./OrganizationsTable";

class Organizations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "1",
      selectedOrganization: null,
      organizationModalVisible: false,
      search: "",
      activeList: [],
      inactiveList: [],
    };
    this.archive = this.archive.bind(this);
    this.unarchive = this.unarchive.bind(this);
    this.edit = this.edit.bind(this);
    this.createOrganization = this.createOrganization.bind(this);
    this.toggle = this.toggle.bind(this);
    this.filter = this.filter.bind(this);
    this.onTextChange = this.onTextChange.bind(this);
  }

  componentDidMount() {
    this.props.getOrganizationTypes();
    this.props.getOrganizationPlans();
    this.props.getOrganizationList();
    // this.props.getTrialInfo();
    if (this.props.getOnboardingFeatures && this.props.selectedOrganization?.id) {
      this.props.getOnboardingFeatures(this.props.selectedOrganization.id);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.orgUpdateLoading && !this.props.orgUpdateLoading) {
      this.setState({
        organizationModalVisible: false,
        selectedOrganization: null,
        search: "",
      });
    }
    if (prevProps.organizations !== this.props.organizations) {
      this.filter(this.props.organizations.list);
    }
    if (prevProps.selectedOrganization?.id !== this.props.selectedOrganization?.id) {
      if (this.props.getOnboardingFeatures && this.props.selectedOrganization?.id) {
        this.props.getOnboardingFeatures(this.props.selectedOrganization.id);
      }
    }
    if (
      this.props.orgCreated &&
      this.props.orgCreated !== prevProps.orgCreated
    ) {
      if (
        this.props.createdOrgId &&
        this.props.createdOrgId !== prevProps.createdOrgId &&
        this.props.createdOrgId !== null &&
        this.props.createdOrgIsActive === false
      ) {
        if (this.props.location.pathname === "/user/organizations") {
          this.props.history.push(
            `/user/subscription?organization_id=${this.props.createdOrgId}`,
          );
        }
      }
    }
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  toggleModal = () => {
    const { organizationModalVisible } = this.state;
    this.setState({
      organizationModalVisible: !organizationModalVisible,
      selectedOrganization: null,
    });
  };

  archive(org) {
    this.props.updateOrganization({ id: org.id, is_active: false });
  }

  unarchive(organization) {
    this.props.selectOrganization(organization);
    // this.props.history.push({
    //   pathname: "/user/subscription",
    //   orgId: organization.id,
    //   unarchive: true,
    // });
    this.props.history.push("/user/current-plan");
  }

  edit(id) {
    const selectedOrganization = this.props.organizations.list.find(org => {
      return org.id === id;
    });
    this.setState({ selectedOrganization, organizationModalVisible: true });
  }

  createOrganization(data) {
    this.props.createOrganization(data);
  }

  onTextChange(e) {
    const search = e.target.value;
    if (search.length - this.state.search.length > 1) {
      return;
    }
    this.setState({ search });
    this.filter(this.props.organizations.list, search);
  }

  handleClearSearch() {
    this.setState({ search: "" });
    this.filter(this.props.organizations.list, "");
  }

  filter(data, search) {
    let activeList = [];
    let inactiveList = [];
    data.forEach(e => {
      if (search && e.name.toLowerCase().indexOf(search.toLowerCase()) === -1) {
        return;
      }
      if (e.is_active) {
        activeList.push(e);
      } else if (!e.is_active) {
        inactiveList.push(e);
      }
    });
    this.setState({ activeList, inactiveList });
  }

  render() {
    const {
      organizationModalVisible,
      selectedOrganization,
      activeList,
      inactiveList,
      search,
      activeTab,
    } = this.state;
    const { organizations, isLoading, orgUpdateLoading, selectedOrganization: org, appOnboardingFeatures, appOnboardingIsFeaturesLoading, dismissOnboardingFeature, dismissFeatureLoading } = this.props;
    const types = organizations && organizations.types;
    const plans = organizations && organizations.plans;
    const showOnboarding = !appOnboardingIsFeaturesLoading && !appOnboardingFeatures?.has_organization && !appOnboardingFeatures?.dismissed_videos?.includes("organization");
    return (
      <div className="content">
        <EditOrganizationModal
          isOpen={organizationModalVisible}
          toggle={this.toggleModal}
          mode={selectedOrganization ? "update" : "create"}
          updateOrganization={this.props.updateOrganization}
          types={types}
          plans={plans}
          organization={selectedOrganization}
          isLoading={orgUpdateLoading}
        />
        <Container
        padding="20px"
        borderRadius="16px 16px 0 0"
        marginTop="32px"
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          gap: "16px",
        }}
      >
        {appOnboardingIsFeaturesLoading ? null : (showOnboarding ? (
          <AppOnboardingIndividualPage
            history={this.props.history}
            selectedOrganization={org}
            page="organization"
            appOnboardingState={appOnboardingFeatures}
            dismissOnboardingFeature={dismissOnboardingFeature}
            dismissFeatureLoading={dismissFeatureLoading}
          />
        ) : (
          <>
        <PageTitle>Organizations</PageTitle>
        <HeaderContainer margin="0px 0 20px 0"> 
          <TabLeftGrid>
            <InputWithLabelSection>
              <FilterLabel>Type</FilterLabel>
              <CommonGrid columns="auto auto" gap="5px">
                <RoundTab
                  text="Active"
                  selected={activeTab === "1"}
                  onClick={() => this.toggle("1")}
                  showIcon={false}
                />
                <RoundTab
                  text="Archived"
                  selected={activeTab === "2"}
                  onClick={() => this.toggle("2")}
                  showIcon={false}
                />
              </CommonGrid>
              {/* <TabButtonContainer width="max-content" disableResponsive>
                <TabButton
                  onClick={() => this.toggle('1')}
                  selected={activeTab}
                  index={'1'}
                >
                  Active
                </TabButton>
                <TabButton
                  onClick={() => this.toggle('2')}
                  selected={activeTab}
                  index={'2'}
                >
                  Archived
                </TabButton>
              </TabButtonContainer> */}
            </InputWithLabelSection>

            <InputWithLabelSection>
              <FilterLabel>Search Organization</FilterLabel>
              <div
                style={{
                  position: "relative",
                }}
              >
                <InputField
                  type="text"
                  placeholder="Search organization by name"
                  value={search}
                  onChange={e => this.onTextChange(e)}
                />
                {search && (
                  <ClearOrgSearchButton
                    onClick={() => this.handleClearSearch()}
                  >
                    <CommonImage src={crossWhite} alt="clear" />
                  </ClearOrgSearchButton>
                )}
              </div>
            </InputWithLabelSection>
          </TabLeftGrid>

          {/* <ColoredButtonWithIcon
            onClick={() => this.props.history.push("/user/add-organization")}
          >
            <ButtonIcon src={Plus} alt="" />
            Add Organization
          </ColoredButtonWithIcon> */}
        </HeaderContainer>
        <Container showBorder={true} padding="0 0 10px 0" marginTop="0">
          {isLoading ? (
            <ComponentCircleLoader />
          ) : activeTab === "1" ? (
            activeList.length ? (
              <OrganizationsTable
                edit={this.edit}
                toggleArchive={this.archive}
                organizationsList={activeList}
                deleteOrganization={this.props.deleteOrganization}
              />
            ) : (
              <NoDataComponent
                padding="4vh 0"
                title={
                  search.trim()
                    ? "No organization found with this name!"
                    : "You don't have active organizations"
                }
              />
            )
          ) : activeTab === "2" ? (
            inactiveList.length ? (
              <OrganizationsTable
                edit={this.edit}
                toggleArchive={this.unarchive}
                organizationsList={inactiveList}
                deleteOrganization={this.props.deleteOrganization}
              />
            ) : (
              <NoDataComponent
                padding="4vh 0"
                title={
                  search.trim()
                    ? "No organization found with this name!"
                    : "You don't have archived organizations"
                }
              />
            )
          ) : (
            <NoDataComponent
              padding="4vh 0"
              title={
                search.trim()
                  ? "No organization found with this name!"
                  : `You don't have any ${
                      activeTab === "1"
                        ? " active"
                        : activeTab === "2"
                        ? " archived"
                        : ""
                    } organizations`
              }
            />
          )}
        </Container>
          </>
        ))}
        </Container>
      </div>
    );
  }
}

export default Organizations;
